// TODO low priority: we should move some of these values into env vars
export const getDiscordLoginUrl = () => {
  // use the shortened URL for production
  if (process.env.NEXT_PUBLIC_ENV === "production") {
    return process.env.NEXT_PUBLIC_DISCORD_LOGIN_LINK ?? "missing-login-link"
  }
  const urlBase = "https://discord.com/api/oauth2/authorize"
  let domain = "joinbonsai.co"
  const clientId = process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    domain = "bonsailocal.com"
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    domain = "staging.joinbonsai.co"
  } else if (process.env.NEXT_PUBLIC_ENV === "playground") {
    domain = "playground.joinbonsai.co"
  }
  const REDIRECT_URI = encodeURIComponent(`https://${domain}/discord/callback`)
  const scope = ["identify", "email", "guilds", "guilds.members.read"]
  const authScope = encodeURIComponent(scope.join(" "))
  return `${urlBase}\?client_id=${clientId}\&redirect_uri=${REDIRECT_URI}\&response_type=code\&scope=${authScope}`
}

export const getDiscordInstallationUrl = () => {
  // use the shortened URL for production
  if (process.env.NEXT_PUBLIC_ENV === "production") {
    return process.env.NEXT_PUBLIC_DISCORD_INSTALL_LINK ?? "missing-installation-link"
  }

  const urlBase = `https://discord.com/api/oauth2/authorize`
  let domain = "joinbonsai.co"
  const clientId = process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    domain = "bonsailocal.com"
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    domain = "staging.joinbonsai.co"
  } else if (process.env.NEXT_PUBLIC_ENV === "playground") {
    domain = "playground.joinbonsai.co"
  }
  const REDIRECT_URI = encodeURIComponent(`https://${domain}/discord/callback`)
  const scope = [
    "identify",
    "email",
    "guilds.members.read",
    "applications.commands",
    "bot",
    "webhook.incoming",
    "guilds",
  ]
  const authScope = encodeURIComponent(scope.join(" "))
  const permissions = process.env.NEXT_PUBLIC_DISCORD_PERMISSIONS ?? "missing-discord-permissions"
  return `${urlBase}\?client_id=${clientId}\&permissions=${permissions}\&redirect_uri=${REDIRECT_URI}\&response_type=code\&scope=${authScope}`
}
